import { GetStaticProps } from 'next'
import Head from 'components/Head'
import Navbar from 'components/Navbar'
import Footer from 'components/Footer'
import PromosProvider from 'components/Promos'
import { loadTranslations } from 'utils/request/i18n'
import {
  NavigationProvider,
  getFilterLimits,
  useTranslation,
  SearchResults,
  withMapContext
} from '@sailogy/shipwright'
import { FilterLimits } from '@sailogy/types'
import { K, i18nPath } from 'i18n/search'

interface Props {
  limits: FilterLimits
}

const Search: React.FC<Props> = ({ limits }) => {
  const t = useTranslation<K>()

  return (
    <NavigationProvider path="/search">
      <Head
        title={t('Find your boat')}
        description={t('Search results for the charter yacht that best suits your sailing vacation.')}
      />
      <Navbar />
      <PromosProvider>
        <SearchResults limits={limits} />
      </PromosProvider>
      <Footer />
    </NavigationProvider>
  )
}

// Build SSG pages for each language
// export const getStaticProps = withI18nStaticProps(i18nPath)
export const getStaticProps: GetStaticProps<Props> = async ({
  params, locale
}) => {
  const [i18n, limits] = await Promise.all([
    loadTranslations(locale!, i18nPath),
    getFilterLimits()
  ])
  return {
    props: { ...params, i18n, i18nPath, limits },
    revalidate: 86400 // 24h to update trip_date options
  }
}

export default withMapContext(Search)
